<template>
  <sidebar-wrapper hide-search>
    <template v-slot:title>
      {{ $t('navbar_settings_hover') }}
    </template>

    <div class="setting-profile-card">
      <div class="account-setting">
        <h5>{{ $t('settings_your_account') }}</h5>
      </div>

      <div class="profile-card">
        <div class="profile-info">
          <div class="profile-listout">
            <p class="info-title mb-0">
              <span>Username</span>
            </p>

            <span class="info-text">
              {{currentUser.username}}
            </span>
          </div>

          <div v-if="!isOperator" class="profile-listout">
            <p class="info-title mb-0">{{ $t('settings_display_name') }}</p>

            <span class="info-text">
              {{currentUser.profile.display_name || '-'}}
            </span>
          </div>

          <div v-if="!isOperator" class="profile-listout">
            <p class="info-title mb-0">{{ $t('settings_bio') }}</p>
            <span class="info-text text-capitalize">{{currentUser.profile.bio_description || '-'}}</span>
          </div>

          <div v-if="!isOperator" class="profile-listout">
            <p class="info-title mb-0">{{ $t('settings_age') }}</p>
            <span class="info-text text-capitalize">{{currentUser.profile.age || '-'}}</span>
          </div>

          <div v-if="!isOperator" class="profile-listout">
            <p class="info-title mb-0">{{ $t('settings_gender') }}</p>
            <span class="info-text text-capitalize">{{currentUser.gender || '-'}}</span>
          </div>

          <div v-if="!isOperator" class="profile-listout mb-0">
            <p class="info-title mb-0">{{ $t('settings_location') }}</p>
            <span class="info-text text-capitalize">{{userLocation || '-'}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="settings-card">
      <div class="settings-control">
        <ul>
          <li v-for="item in SettingsSidebar" :key="item.id">
            <a
              :href="item.redirect ? item.dataTarget : '#'"
              :target="item.redirect ? '_blank' : ''"
              :data-bs-toggle="item.redirect ? '' : item.dataToggle"
              :data-bs-target="item.redirect ? '' : item.dataTarget"
            >
              <div class="setting-card-list">
                <i :class="item.iconClass"></i>
                <span>{{ $t(item.linkText) }}</span>
              </div>
              <i v-if="!item.redirect" class="bx bx-chevron-right"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </sidebar-wrapper>
</template>

<script>
import SettingsSidebar from "@/assets/json/frontend/settings-sidebar.json";
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters({
      currentUser: 'auth/user',
      isOperator: 'isOperator',
      countries: 'misc/countries',
    }),

    userLocation() {
      return this.currentUser.profile.country
        ? this.countries.find(e => e.id === this.currentUser.profile.country)?.text
        : '-';
    },
  },

  data() {
    return {
      SettingsSidebar: SettingsSidebar,
      profile_picture: '',
    };
  },

  methods: {
    async changeProfilePicture(event) {
      this.profile_picture = event.target.files[0];

      const r = await this.$store.dispatch('uploadImage', {
        category: 'profile_picture',
        picture: this.profile_picture,
      });

      this.profile_picture = '';
      event.target.value = null;
    },
  },
};
</script>
